<!--
 * @Author: Shber
 * @Date: 2023-02-07 10:34:08
 * @LastEditors: Shber
 * @LastEditTime: 2023-05-19 11:31:42
 * @Description:
-->
<template>
  <div>
    <div v-if="content.news_pic!= ''" class="inf_focus_zt">
      <div class="bd">
        <!-- <img :src="content.news_pic" class="fig_bg_img" @load="loadImage"> -->
        <van-image class="van_img fig_bg_img" lazy-load :src="content.news_pic" @load="loadImage" />
        <div class="fig_news">
          <div v-if="content.news_title!==''" class="fig_pic_title"> {{ content.news_title }} </div>
          <div v-if="content.news_subtitle!==''" class="fig_pic_subTitle"> {{ content.news_subtitle }} </div>
        </div>
      </div>
    </div>
    <!-- markdown内容展示 -->
    <div
      v-if="content.new_lead_top != ''"
      v-lazy-container="{ selector: 'img' }"
      class="inf_con_zt fig_no_top_contetn"
      v-html="content.new_lead_top"
    />
    <div v-else class="inf_noe" />
    <!-- markdown内容展示 end -->

    <!-- 底部markdown编辑的信息内容 -->
    <div v-if="content.produce_name!==''||content.produce_duty!==''||content.produce_content" class="fig_brief">
      <p :class="{fig_brief_name:content.produce_name!==''}">{{ content.produce_name }}</p>
      <p :class="{fig_brief_post: content.produce_duty!==''}">{{ content.produce_duty }}</p>
      <p :class="{fig_brief_brief:content.produce_content!==''}" v-html="content.produce_content.replace(/\n/g,'<br/>')" />
    </div>
    <!-- 底部markdown编辑的信息内容 end -->

    <div v-if="content.recommend_food.length>0" class="fig_comment">
      <div class="comment_title">推荐作品</div>
      <div class="comment_list">
        <ul>
          <li v-for="item in content.recommend_food" :key="item.id">
            <div>
              <a :href="item.link">
                <div class="list_item_con">
                  <div class="list_item_l">
                    <!-- <img v-lazy="item.pic"> -->
                    <van-image class="van_img" lazy-load :src="item.pic" />
                    <template v-if="item.foodlive!==''">
                      <div class="list_item_imgShadow" />
                      <img src="https://static.mingchu.co/webapp/images/figure/icon_play@2x.png" class="list_item_video">
                    </template>
                  </div>
                  <div class="list_item_r">
                    <p class="item_title item_food_title">{{ item.food_name }}</p>
                    <p class="item_cont">{{ item.title }}</p>
                    <p class="item_collect">{{ item.food_like }}人收藏</p>
                  </div>
                </div>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="content.relevant_recommend.length>0" class="fig_comment about_content">
      <div class="comment_title"> {{ $t('topHeader.recoText') }} </div>
      <div class="comment_list">
        <ul>
          <li v-for="item in content.relevant_recommend" :key="item.id">
            <div class="div">
              <a class="a" :href="item.link">
                <div class="list_item_con">
                  <div class="list_item_l">
                    <img v-lazy="item.pic" class="img1">
                    <!-- <van-image class="img1" lazy-load :src="item.pic" /> -->
                    <template v-if="item.type ==6">
                      <div class="list_item_imgShadow" />
                    <!-- <img src="https://static.mingchu.co/webapp/images/figure/icon_play@2x.png" class="list_item_video" style="top:21px"> -->
                    </template>
                  </div>
                  <div class="list_item_r" style="height:80px">
                    <p class="item_title item_about_title" v-html="item.title" />
                    <p class="item_txt" style="bottom:-4px">
                      <span class="item_txt_people" style="color:#9B9B9B">{{ item.stitle }} </span>
                      <span v-if="item.type ==2 || item.type ==3" class="item_txt_data">
                        | {{ getDate('yyyy.mm.dd',item.time) }}
                      </span>
                      <span v-else-if="item.type == 7" class="item_txt_data" />
                      <span v-else class="item_txt_data"> | {{ item.time }}</span>
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="zan_magrin" />
  </div>
</template>
<script setup>
import { onMounted, defineEmits, defineProps } from 'vue'
import { Image as vanImage } from 'vant'

const emits = defineEmits(['onFinish'])
const props = defineProps({
  content: { // 内容对象
    type: Object,
    default: () => {}
  }
})
// const new_lead_top_class_is = ref(true)
// let patt = '</p>'
// patt = new RegExp(patt)
// if (patt.test(props.content.new_lead_top)) {
//   new_lead_top_class_is.value = false
// }

onMounted(() => {
  console.log('content', props.content)
  emits('onFinish', false)
})

const loadImage = (value) => {
  emits('onFinish', false)
}

// 转换年月日方法
const getDate = (format, str) => {
  const oDate = new Date(str * 1000)
  const oYear = oDate.getFullYear()
  const oMonth = oDate.getMonth() + 1
  const oDay = oDate.getDate()

  // const oHour = oDate.getHours()
  // const oMin = oDate.getMinutes()
  // const oSec = oDate.getSeconds()
  let oTime

  if (format === 'yyyy-mm-dd') {
    oTime = oYear + '-' + getzf(oMonth) + '-' + getzf(oDay) // 最后拼接时间
  } else if (format === 'yyyy/mm/dd') {
    oTime = oYear + '/' + getzf(oMonth) + '/' + getzf(oDay)// 最后拼接时间
  } else {
    oTime = oYear + '.' + getzf(oMonth) + '.' + getzf(oDay)// 最后拼接时间
  }
  return oTime
}
const getzf = (num) => {
  if (parseInt(num) < 10) {
    num = '0' + num
  }
  return num
}

</script>
